import { inject } from "@angular/core";
import { type CanActivateFn, Router } from "@angular/router";

import { map } from "rxjs";

import { WMS_WRITE_ROLES } from "@/app/features/wms/shared/utils/wms-roles.util";
import { AuthService } from "../services/auth.service";
import { hasGrantedRole } from "./role-hierarchy";

/**
 * Guard of the screens that write in the WMS (the returns): logistician, supply chain manager and admin, never the
 * customer service, which only reads. The server asks for the same right (ROLE_WMS_WRITE).
 */
export const WmsWriteGuard: CanActivateFn = () => {
  const router = inject(Router);

  return inject(AuthService)
    .loadUser()
    .pipe(
      map((user) =>
        WMS_WRITE_ROLES.some((role) => hasGrantedRole(user.roles, role))
          ? true
          : router.parseUrl("/403"),
      ),
    );
};
